export default __webpack_public_path__ + "static/media/usd.c42b17cd.svg";